export const fonts = {
	body: `'Manrope', sans-serif`,
	heading: `'Gambetta', serif`,
};
